import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { deleteAsset } from '../store/assetActions';

DeleteAsset.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  asset: PropTypes.object,
};

/**
 * Confirms retiring an asset.
 *
 * Deliberately not the shared `ConfirmationDialog`, which is hard-wired to the
 * categories package's delete action.
 */
export default function DeleteAsset({ open, handleClose, asset }) {
  const dispatch = useDispatch();
  const { isSaving } = useSelector((state) => state.assetReducer);

  const handleDelete = async () => {
    const result = await dispatch(deleteAsset(asset?.id));
    // Only close on success, so a rejection (for example an asset that is still
    // in maintenance) leaves the dialog up with the toasted reason.
    if (result?.ok) handleClose(true);
  };

  return (
    <Dialog open={open} onClose={() => handleClose(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Delete {asset?.name || 'this asset'}?</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {asset?.barcode_number ? `Barcode ${asset.barcode_number}. ` : ''}
          The asset will be removed from asset lists and reports.
        </DialogContentText>
        <Alert severity="info">
          Its maintenance, repair and invoice history is kept, so past records stay intact.
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button size="small" variant="outlined" onClick={() => handleClose(false)}>
          Cancel
        </Button>
        <LoadingButton size="small" color="error" variant="contained" loading={isSaving} onClick={handleDelete}>
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
